/** @jsxImportSource react */
import type { SVGProps } from 'react';
const LegacyEmptySymbols = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 140 140" {...props}>
    <path
      fill="#CBCFD8"
      d="M126.886 64.572a3 3 0 0 0-.184-3.282l-3.211-4.349a3 3 0 0 0-1.521-1.082l-11.275-3.513a3 3 0 0 0-3.49 1.365l-6.613 11.453a3 3 0 0 1-4.098 1.098l-11.603-6.7a3 3 0 0 0-3.552.41l-10.26 9.62a2 2 0 0 0-.595 1.834l.983 5.14a3 3 0 0 0 1.447 2.034l11.164 6.446c1.822 1.051 2.023 3.602.39 4.927l-6.39 5.184a2 2 0 0 0-.706 1.92l.917 4.921a3 3 0 0 0 1.45 2.048l15.67 9.047a3 3 0 0 0 4.098-1.098l6.312-10.933a3 3 0 0 1 4.098-1.098l10.933 6.312a3 3 0 0 0 4.098-1.098l8.759-15.17a3 3 0 0 0-.18-3.275l-3.163-4.31a3 3 0 0 0-1.757-1.152l-6.077-1.373a3 3 0 0 1-1.937-4.426z"
    />
    <path
      fill="#E2E4EA"
      d="M123.152 60.84a4 4 0 0 0-1.464-5.464l-12.536-7.238a4 4 0 0 0-5.464 1.465l-5.312 9.2a4 4 0 0 1-5.464 1.465l-9.202-5.312a4 4 0 0 0-5.464 1.464L71.01 68.955a4 4 0 0 0 1.464 5.465l9.201 5.312a4 4 0 0 1 1.464 5.464l-5.312 9.201a4 4 0 0 0 1.464 5.464l12.536 7.238a4 4 0 0 0 5.464-1.464l5.312-9.201a4 4 0 0 1 5.464-1.465l9.201 5.313a4 4 0 0 0 5.464-1.464l7.238-12.536a4 4 0 0 0-1.464-5.464l-9.201-5.313a4 4 0 0 1-1.464-5.464z"
    />
    <path stroke="#1E2024" strokeLinecap="round" d="M96.685 77.785a5.917 5.917 0 0 0 7.215 4.238" />
    <circle cx={106.17} cy={76.598} r={2.192} fill="#1E2024" transform="rotate(30 106.17 76.598)" />
    <circle cx={105.118} cy={74.569} r={1.337} fill="#fff" transform="rotate(30 105.118 74.57)" />
    <circle cx={99.085} cy={72.508} r={2.192} fill="#1E2024" transform="rotate(30 99.085 72.508)" />
    <circle cx={98.364} cy={70.771} r={1.337} fill="#fff" transform="rotate(30 98.364 70.771)" />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      d="m114.031 98.4 4.109 2.371a3 3 0 0 0 4.098-1.098l1.483-2.569"
    />
    <path
      fill="#E2E4EA"
      d="M19.996 24.289a6 6 0 0 0-3.952 3.408l-3.395 7.83a6 6 0 0 0-.29 3.94l4.879 18.21a6 6 0 0 0 7.348 4.242l52.782-14.142a6 6 0 0 0 3.958-3.424l3.363-7.811a6 6 0 0 0 .284-3.925l-4.882-18.22a6 6 0 0 0-7.348-4.242z"
    />
    <path
      fill="#CBCFD8"
      d="m24.635 45.151-6.542-17.768c-.312-.846-1.495-.88-1.855-.055l-3.558 8.148a6.25 6.25 0 0 0-.31 4.118l4.846 18.088a6 6 0 0 0 7.332 4.247L76.86 48.065a7 7 0 0 0 4.667-4.07l3.109-7.45a1 1 0 0 0-1.184-1.351L32.126 49.026a6.25 6.25 0 0 1-7.491-3.875"
    />
    <path
      stroke="#1E2024"
      strokeLinecap="round"
      d="m80.634 36.037-7.759 2.08M23.09 40.835l1.64 4.362a6.25 6.25 0 0 0 7.458 3.842l3.604-.959M49.394 33.442a5.883 5.883 0 0 0 8.052-2.094"
    />
    <circle cx={55.228} cy={25.939} r={2.179} fill="#1E2024" transform="rotate(-15 55.228 25.939)" />
    <circle cx={53.062} cy={25.251} r={1.33} fill="#fff" transform="rotate(-15 53.062 25.25)" />
    <circle cx={47.371} cy={28.044} r={2.179} fill="#1E2024" transform="rotate(-15 47.371 28.044)" />
    <circle cx={45.642} cy={27.331} r={1.33} fill="#fff" transform="rotate(-15 45.642 27.33)" />
    <path
      fill="#E2E4EA"
      d="M72.072 105.653a5.17 5.17 0 0 0-1.865-2.874l-33.63-25.973c-2.62-2.023-6.441-1.097-7.844 1.902l-17.995 38.485a5.17 5.17 0 0 0-.341 3.409l1.874 7.729a5.17 5.17 0 0 0 6.243 3.806l51.624-12.508a5.17 5.17 0 0 0 3.807-6.243z"
    />
    <path stroke="#1E2024" strokeLinecap="round" d="M32.333 97.157a5.917 5.917 0 0 0 8.249-1.408" />
    <circle cx={38.823} cy={90.138} r={2.192} fill="#1E2024" transform="rotate(-10.11 38.823 90.138)" />
    <circle cx={36.711} cy={89.264} r={1.337} fill="#fff" transform="rotate(-10.11 36.71 89.264)" />
    <circle cx={30.769} cy={91.574} r={2.192} fill="#1E2024" transform="rotate(-10.11 30.77 91.574)" />
    <circle cx={29.098} cy={90.71} r={1.337} fill="#fff" transform="rotate(-10.11 29.098 90.71)" />
    <path
      fill="#CBCFD8"
      d="M10.577 121.345a2.585 2.585 0 0 1 1.903-3.121l56.649-13.726a2.585 2.585 0 0 1 3.121 1.904l1.692 6.985a5.17 5.17 0 0 1-3.807 6.242l-51.623 12.508a5.17 5.17 0 0 1-6.243-3.807z"
    />
    <path stroke="#1E2024" strokeLinecap="round" d="m15.977 117.309 14.454-3.487" />
  </svg>
);
export default LegacyEmptySymbols;
